import React from "react";
import styled from "styled-components";
import InviteUsersTab from "../../../components/Account/InviteUsersTab";

const PageHeader = styled.div`
  margin-bottom: 24px;
  h1 { font-size: 24px; font-weight: 600; color: #014c75; margin: 0 0 8px 0; }
  p { color: #666; margin: 0; font-size: 14px; }
`;

const TeamMembersWrapper = styled.div``;

const TeamMembers = ({ role = "customer" }) => {
  return (
    <TeamMembersWrapper>
      <PageHeader>
        <h1>Team Members</h1>
        <p>Manage your team members and send invitations to new users to join your organization.</p>
      </PageHeader>
      <InviteUsersTab role={role} />
    </TeamMembersWrapper>
  );
};

export default TeamMembers;
